import React from 'react';
import PropTypes from 'prop-types';

import styles from './ProgressBar.css';


const PROGRESSBAR_VARIANTS = {
  grid: 'grid',
  modal: 'modal',
  slide: 'slide',
};

function ProgressBar({ progress, type }) {
  if (type === PROGRESSBAR_VARIANTS.slide) {
    if (progress === null) {
      return null;
    }

    return (
      <div className={styles.container}>
        <div className={styles.containerSlider}>
          <div
            className={styles.fillerSlide}
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className={styles.trophiesProgress}>
          {progress}%
        </p>
      </div>
    );
  }

  if (type === PROGRESSBAR_VARIANTS.grid) {
    const className = progress !== null ? styles.containerGrid : styles.containerHidden;

    return (
      <div className={className}>
        <div
          className={styles.fillerGrid}
          style={{ width: `${progress}%` }}
        />
      </div>
    );
  }

  if (type === PROGRESSBAR_VARIANTS.modal) {
    const className = progress !== null ? styles.containerModal : styles.containerHidden;

    return (
      <div className={className}>
        <div
          className={styles.fillerGrid}
          style={{ width: `${progress}%` }}
        />
      </div>
    );
  }

  return null;
}

ProgressBar.propTypes = {
  progress: PropTypes.number,
  type: PropTypes.oneOf(Object.values(PROGRESSBAR_VARIANTS)),
};

ProgressBar.defaultProps = {
  progress: null,
  type: PROGRESSBAR_VARIANTS.modal,
};

export default ProgressBar;
